<div data-m-target="New point button" class="mobileNewPointButton" (click)="action()">
  <img class="mobileNewPointButton__icon" [src]="EIconPath.PLUS_THICKER" />
</div>
